import { AxiosError } from 'axios';

export function isNetworkError(error: unknown): boolean {
  if (!error) return false;
  if (error instanceof AxiosError) {
    if (!error.response) return true;
    const code = (error as AxiosError & { code?: string }).code;
    if (code === 'ECONNABORTED' || code === 'ERR_NETWORK') return true;
    if (error.message?.includes('Network Error')) return true;
  }
  if (error instanceof Error) {
    const msg = error.message.toLowerCase();
    return msg.includes('network error') || msg.includes('econnrefused') || msg.includes('failed to fetch');
  }
  return false;
}

export function networkErrorMessage(error: unknown): string {
  if (isNetworkError(error)) {
    return import.meta.env.DEV
      ? 'Cannot reach the API server. Start the backend with: cd backend && npm run dev'
      : 'Unable to connect. Please try again.';
  }
  if (error instanceof AxiosError) {
    return error.response?.data?.message || error.message || 'Request failed';
  }
  if (error instanceof Error) return error.message;
  return 'Something went wrong';
}
